import { createRouter, createWebHistory } from "vue-router";
import { getToken, useAuth } from "../composables/useAuth";
import LoginView from "../views/LoginView.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: LoginView,
    },
    {
      path: "/password",
      name: "password",
      component: () => import("../views/PasswordView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/current-term",
      name: "current-term",
      component: () => import("../views/CurrentTermView.vue"),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: "/current-coaches",
      name: "current-coaches",
      component: () => import("../views/CurrentCoachesView.vue"),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: "/coach-workspace",
      name: "coach-workspace",
      component: () => import("../views/CoachWorkspaceView.vue"),
      meta: { requiresAuth: true, requiresCoach: true },
    },
    {
      path: "/assistant-workspace",
      name: "assistant-workspace",
      component: () => import("../views/AssistantWorkspaceView.vue"),
      meta: { requiresAuth: true, requiresAssistant: true },
    },
    {
      path: "/supervision-workspace",
      name: "supervision-workspace",
      component: () => import("../views/SupervisionWorkspaceView.vue"),
      meta: { requiresAuth: true, requiresSupervisionCoordinator: true },
    },
    {
      path: "/coach-library",
      name: "coach-library",
      component: () => import("../views/CoachLibraryView.vue"),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: "/accounts",
      name: "accounts",
      component: () => import("../views/AccountView.vue"),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: "/serving-coaches",
      name: "serving-coaches",
      component: () => import("../views/ServingCoachesView.vue"),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: "/deferred",
      name: "deferred",
      component: () => import("../views/DeferredStudentsView.vue"),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: "/archive",
      name: "archive",
      component: () => import("../views/ArchiveView.vue"),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/current-coaches",
    },
  ],
});

router.beforeEach(async (to, _from, next) => {
  const auth = useAuth();

  if (to.meta.requiresAuth) {
    const token = getToken();
    if (!token) {
      next("/login");
      return;
    }
    if (!auth.user.value) {
      await auth.fetchMe();
    }
    if (!auth.user.value) {
      next("/login");
      return;
    }
    const roles = Array.isArray(auth.user.value.roles) ? auth.user.value.roles : [];
    const homePath = roles.includes("admin") ? "/current-coaches" : roles.includes("coach") ? "/coach-workspace" : roles.includes("assistant") ? "/assistant-workspace" : "/supervision-workspace";
    if (to.meta.requiresAdmin && !roles.includes("admin")) {
      next(homePath);
      return;
    }
    const isAdminPreview = to.meta.requiresCoach && to.query.preview === "1" && roles.includes("admin");
    if (to.meta.requiresCoach && !roles.includes("coach") && !isAdminPreview) {
      next(homePath);
      return;
    }
    const isAssistantPreview = to.meta.requiresAssistant && to.query.preview === "1" && roles.includes("admin");
    if (to.meta.requiresAssistant && !roles.includes("assistant") && !isAssistantPreview) {
      next(homePath);
      return;
    }
    const isAdminSupervisionPreview = to.meta.requiresSupervisionCoordinator && to.query.preview === "1" && roles.includes("admin");
    if (to.meta.requiresSupervisionCoordinator && !roles.includes("supervision_coordinator") && !isAdminSupervisionPreview) {
      next(homePath);
      return;
    }
  }

  if (to.path === "/login") {
    const token = getToken();
    if (token) {
      const roles = Array.isArray(auth.user.value?.roles) ? auth.user.value.roles : [];
      next(roles.includes("admin") ? "/current-coaches" : roles.includes("coach") ? "/coach-workspace" : roles.includes("assistant") ? "/assistant-workspace" : "/supervision-workspace");
      return;
    }
  }

  next();
});

export { router };
